import { useDispatch } from 'react-redux';
import { Accordion, AccordionDetails, AccordionSummary, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ONLYFANS_NETWORK_ID, screenshotNetworkMapping } from 'utils/helpers';
import { openModal } from 'features/utilsSlice';
import ChevronRight from 'public/icons/chevron-right-white.svg';
import ChevronRightIcon from 'public/icons/chevron-right.svg';
import CheckIcon from 'public/icons/check-circle-green.svg';
import CloseIcon from 'public/icons/close-circle-red.svg';
import clsx from 'clsx';

const useStyles = makeStyles({
  content: {
    margin: 0,
    fontFamily: 'Avenir Heavy',
    fontSize: 16,
    alignItems: 'center',
    order: 2,
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff5f5',
    padding: '15px 15px 10px 15px',
  },

  expanded: {
    margin: '0px !important',
    minHeight: '50px !important',
    alignItems: 'center',
  },

  expandIcon: {
    margin: 0,
    padding: 0,
    transform: 'rotate(0deg)',

    '&$expanded': {
      transform: 'rotate(90deg)',
    },
  },

  paper: {
    boxShadow: 'none',
    margin: '0 !important',

    '&::before': {
      display: 'none',
    },
  },
});

const VerificationAccordion = ({
  influencerNetwork = {},
  styles = {},
  automaticVerification = true,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const requiredScreenshots = screenshotNetworkMapping[influencerNetwork.network.name];

  const completedCount = requiredScreenshots.reduce((acc, screenshot) => {
    if (['pending_verification', 'verified'].includes(influencerNetwork[screenshot.status_key])) {
      return acc + 1;
    }

    return acc;
  }, 0);

  if (influencerNetwork.network.name === 'Image & Likeness') return null;

  return (
    <Accordion className={clsx(classes.paper, styles.notVerified)}>
      <AccordionSummary
        classes={{
          content: classes.content,
          expanded: classes.expanded,
          expandIcon: classes.expandIcon,
          details: classes.details,
        }}
        expandIcon={
          automaticVerification ? (
            <ChevronRightIcon className={styles.chevronIcon} width={16} height={16} />
          ) : null
        }
      >
        {automaticVerification ? (
          <span className={styles.text}>
            {completedCount === 0
              ? '0 completed'
              : `Not verified (${completedCount} of ${requiredScreenshots.length} completed)`}
          </span>
        ) : (
          <span className={styles.text}>Not verified</span>
        )}

        <Button
          variant="contained"
          color="primary"
          className={styles.button}
          endIcon={<ChevronRight />}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();

            // OnlyFans Verification
            if (influencerNetwork.network_id === ONLYFANS_NETWORK_ID) {
              dispatch(
                openModal({
                  name: 'Influencer OnlyFans Verification',
                  data: { influencerNetworkId: influencerNetwork.id },
                })
              );
            } else {
              dispatch(
                openModal({
                  name: 'Inventory Edit',
                  data: {
                    step: 'Profile Verification',
                    influencerNetworkId: influencerNetwork.id,
                  },
                })
              );
            }
          }}
        >
          <span style={{ marginTop: 2 }}>Verify</span>
        </Button>
      </AccordionSummary>
      <AccordionDetails className={classes.root}>
        <p>
          You need to verify your social media account so that we can match you with advertisers.
        </p>

        <div style={{ marginTop: 15, display: 'flex', flexWrap: 'wrap' }}>
          {screenshotNetworkMapping[influencerNetwork.network.name].map(screenshot => (
            <div
              key={screenshot.name}
              className={styles.label}
              style={
                ['pending_verification', 'verified'].includes(
                  influencerNetwork[screenshot.status_key]
                )
                  ? { opacity: 0.5 }
                  : {}
              }
            >
              {['pending_verification', 'verified'].includes(
                influencerNetwork[screenshot.status_key]
              ) ? (
                <CheckIcon width={16} height={16} />
              ) : (
                <CloseIcon />
              )}
              <span style={{ fontFamily: 'Avenir-Heavy', marginLeft: 5 }}>{screenshot.label}</span>
            </div>
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default VerificationAccordion;
